import Stack from '@mui/material/Stack'
import HgfButton from './ui/HgfButton'
import BaseSurfaceRounded from '~/components/layout/BaseSurfaceRounded'
import HgfCounterBox from './counter/HgfCounterBox'
import {getGeneralIndicatorMetrics} from '~/components/software/indicator/apiSoftwareIndicator'

export default function SoftwareQualityIndicatorSection({metrics}: {metrics: {evaluations_started: number, centres_associated: number, pof_topics_associated: number} | null}) {

  return (
    <section id='helmholtz-software-quality-indicator' className='bg-[#ecfbfd] w-full'>
      <div className='mx-auto p-6 md:p-10 xl:py-10 max-w-(--breakpoint-xl) my-12'>
        <h2 className="text-5xl mb-4">The Helmholtz Software Quality Indicator</h2>
        <div className='text-2xl mt-2'>Acknowledging research software as scientific output.</div>
        <div className='grid grid-cols-3 gap-4 pt-10 pb-4'>
          <HgfCounterBox label="Evaluations" value={metrics?.evaluations_started || 0} />
          <HgfCounterBox label="Helmholtz centres associated with evaluations" value={metrics?.centres_associated || 0} />
          <HgfCounterBox label="PoF topics associated with evaluations" value={metrics?.pof_topics_associated || 0} />
        </div>
        <Stack direction='row' className='justify-between gap-4 items-stretch'>
          <BaseSurfaceRounded className='p-6 flex-1 flex flex-col my-2'>
            <h3 className='text-2xl'>For Software Maintainers</h3>
            <div className='text-xl my-4 grow'>
              <p>Evaluate your research software based on the <span className="hgf-text-highlight">Helmholtz Software Quality Indicator</span> directly in the RSD.</p>
            </div>
            <HgfButton
              style='primary'
              className='w-full'
              href='/documentation/indicator/For-maintainers/'
            >About Evaluation</HgfButton>
          </BaseSurfaceRounded>
          <BaseSurfaceRounded className='p-6 flex-1 flex flex-col my-2'>
            <h3 className='text-2xl'>For Organisation Reporters</h3>
            <div className='text-xl my-4 grow'>
              <p>Use the RSD to collect your centre evaluation results for PoF reporting.</p>
            </div>
            <HgfButton
              style='primary'
              className='w-full'
              href='/documentation/indicator/For-reporters/'
            >About Reporting</HgfButton>
          </BaseSurfaceRounded>
        </Stack>
      </div>
    </section>
  )
}
